module.exports = __webpack_public_path__ + "static/img/property_1_dana.d44dbff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/property_1_dana.png
// module id = 6PCg
// module chunks = 1